export function attachTabEvents(element: Element, instance: any, shadowRoot: ShadowRoot | null) {
    if (!shadowRoot) return;
  
    // Ensure only one click listener per element
    element.removeEventListener('click', handleTabClick);
    element.addEventListener('click', handleTabClick);
  
    function handleTabClick(event: Event) {
      event.preventDefault();
      instance.show();
    }
  
    // Handle Bootstrap Tab 'show' and 'hide' events
    element.removeEventListener('show.bs.tab', handleTabShow);
    element.removeEventListener('hide.bs.tab', handleTabHide);
    element.addEventListener('show.bs.tab', handleTabShow);
    element.addEventListener('hide.bs.tab', handleTabHide);
  
    function handleTabShow(event: Event) {
      const targetEl = event.target as HTMLElement;
      if (targetEl.dataset?.bsTarget) {
        shadowRoot?.querySelector(targetEl.dataset.bsTarget)?.classList.add('active', 'show');
      }
    }
  
    function handleTabHide(event: Event) {
      const targetEl = event.target as HTMLElement;
      if (targetEl.dataset?.bsTarget) {
        shadowRoot?.querySelector(targetEl.dataset.bsTarget)?.classList.remove('active', 'show');
      }
    }
  }
  